import http from 'utils/http';
import { getAgentTypeOptionsUrl } from './apiUrls';

export function getAgentTypeOptions(): Promise<{ data: string[] }> {
  return http.get(getAgentTypeOptionsUrl());
}
